var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer_service_icon"},[_c('div',{staticClass:"coze_btn_text",on:{"click":_vm.openCoze}},[_c('i',{staticClass:"iconfont-v3 saasline-robot"}),_c('span',[_vm._v(_vm._s(_vm.$t('lang.k_035001')))])]),_c('div',{attrs:{"id":"coze_btn"}},[_vm._v(_vm._s(_vm.$t('lang.k_035002')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }